import { environment } from '../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ApiResponse } from '../dto/api-response.response';
import { DocumentSeriesResponse } from '../dto/document-series.response';
import { DocumentSeriesCreateRequest } from '../dto/document-series-create.request';
import { DocumentSeriesUpdateRequest } from '../dto/document-series-update.request';

@Injectable({
    providedIn: 'root',
})
export class DocumentSeriesService {

    private readonly baseUrl = `${environment.apiUrl}/document-series`;

    constructor(private http: HttpClient) { }

    findAll(): Observable<ApiResponse<DocumentSeriesResponse[]>> {
        return this.http.get<ApiResponse<DocumentSeriesResponse[]>>(this.baseUrl);
    }

    create(req: DocumentSeriesCreateRequest): Observable<ApiResponse<DocumentSeriesResponse>> {
        return this.http.post<ApiResponse<DocumentSeriesResponse>>(this.baseUrl, req);
    }

    update(id: number, req: DocumentSeriesUpdateRequest): Observable<ApiResponse<DocumentSeriesResponse>> {
        return this.http.put<ApiResponse<DocumentSeriesResponse>>(`${this.baseUrl}/${id}`, req);
    }

    toggleStatus(id: number): Observable<ApiResponse<DocumentSeriesResponse>> {
        return this.http.patch<ApiResponse<DocumentSeriesResponse>>(`${this.baseUrl}/${id}/status`, {});
    }

    getNextSequence(documentTypeCode: string): Observable<ApiResponse<DocumentSeriesResponse>> {
        const params = new HttpParams().set('documentTypeCode', documentTypeCode);
        return this.http.get<ApiResponse<DocumentSeriesResponse>>(`${this.baseUrl}/next-sequence`, { params });
    }

    getNextSequenceById(seriesId: number): Observable<ApiResponse<DocumentSeriesResponse>> {
        const params = new HttpParams().set('seriesId', seriesId);
        return this.http.get<ApiResponse<DocumentSeriesResponse>>(`${this.baseUrl}/next-sequence`, { params });
    }
}
